export const SQL_EDITOR_ARIA_LABEL = 'SQL query editor';
